export const API = {
	REQUEST_TOKEN: {
		url: 'member/auth/request/token',
		type: 'post',
	},
	LOGIN_TOKEN: {
		url: 'member/auth/login/token',
		type: 'post'
	},
	PROFILE: {
		url: 'member/profile',
		type: 'get'
	},
	PROFILE_UPDATE: {
		url: 'member/profile',
		type: 'put'
	},
	DEFAULT_STORE: {
		url: 'member/default-store',
		type: 'put'
	},
	PROFILE_PHOTO_UPLOAD: {
		url: 'member/profile/photo',
		type: 'post'
	},
	PROFILE_EMAIL_REQUEST: {
		url: 'member/profile/email/request',
		type: 'post'
	},
	PROFILE_EMAIL_VERIFY: {
		url: 'member/profile/email/verify',
		type: 'post'
	},
	PROFILE_PHONE_REQUEST: {
		url: 'member/profile/phone/request',
		type: 'post'
	},
	PROFILE_PHONE_VERIFY: {
		url: 'member/profile/phone/verify',
		type: 'post'
	},
	MEMBER_ACTIVITY_HISTORY: {
		url: 'member/activity-history',
		type: 'get'
	},
	MEMBER_PRODUCT_PAGE_VISIT: {
		url: 'member/activity-history/product-page',
		type: 'post'
	},
	PUBLIC_PRODUCT_PAGE_VISIT: {
		url: 'public/activity-history/product-page',
		type: 'post'
	},
	POINT: {
		url: 'member/points',
		type: 'get'
	},

	VOUCHER: {
		url: 'member/vouchers',
		type: 'get'
	},

	REDEEM_VOUCHER: {
		url: "member/redeem/voucher",
		type: "get"
	},
	GLOBAL_VOUCHER: {
		url: "member/checkout/global-vouchers",
		type: "get"
	},
	OFFLINE_VOUCHER_QR: {
		url: "member/redeem/offline-qr",
		type: "post"
	},
	REDEEM: {
		url: "member/redeem",
		type: "post"
	},
	REDEEM_REQUEST: {
		url: "member/vouchers/purchase/request",
		type: "post"
	},
	REDEEM_VERIFY: {
		url: "member/vouchers/purchase/verify",
		type: "post"
	},
	MERCHANT: {
		url: "member/partner",
		type: "get"
	},
	MERCHANT_DETAIL: {
		url: "member/partner/detail",
		type: "get"
	},
	REGISTER: {
		url: "merchant/member/register",
		type: "post"
	},
	PRODUCT: {
		url: "member/product",
		type: 'get'
	},
	PRODUCT_GET: {
		url: "member/product/get",
		type: 'get'
	},
	STORE: {
		url: "member/store",
		type: 'get'
	},
	STORE_GET: {
		url: "member/store/get",
		type: 'get'
	},

	ADD_CART: {
		url: "member/cart",
		type: 'post'
	},
	CART: {
		url: "member/cart",
		type: 'get'
	},
	EDIT_CART: {
		url: "member/cart",
		type: 'put'
	},
	DELETE_CART: {
		url: "member/cart",
		type: 'delete'
	},

	ADDRESS: {
		url: "member/address",
		type: 'get'
	},
	ADDRESS_GET: {
		url: "member/address/get",
		type: 'get'
	},

	ADDRESS_CREATE: {
		url: "member/address",
		type: 'post'
	},
	ADDRESS_EDIT: {
		url: "member/address",
		type: 'put'
	},
	ADDRESS_DELETE: {
		url: "member/address",
		type: 'delete'
	},
	PROVINCE: {
		url: "member/master/province",
		type: "get"
	},
	CITY: {
		url: "member/master/city",
		type: "get"
	},
	AUTH: {
		url: "member/auth",
		type: "get"
	},
	SHIPPING: {
		url: "member/shipping/cost",
		type: "get"
	},
	GOSEND_SHIPPING_COST: {
		url: "member/transaction/shipping/gosend/cost",
		type: "get"
	},
	MS_PAYMENT: {
		url: "member/master/payment",
		type: "get"
	},
	DELIVERY: {
		url: "member/master/delivery",
		type: "get"
	},
	PUBLIC_STORE: {
		url: "public/store",
		type: "get"
	},
	PUBLIC_PARTNER: {
		url: "public/partner",
		type: "get"
	},
	PUBLIC_PROMO_BANNERS: { url: 'public/promo-banners', type: 'get' },
	CHECKOUT_QUOTE: {
		url: "member/checkout/quote",
		type: 'post'
	},
	CHECKOUT_COMMIT: {
		url: "member/checkout/commit",
		type: 'post'
	},
	WALLET: { url: 'member/wallet', type: 'get' },
	WALLET_TRANSACTIONS: { url: 'member/wallet/transactions', type: 'get' },
	WITHDRAWALS: { url: 'member/withdrawals', type: 'get' },
	WITHDRAWAL_CREATE: { url: 'member/withdrawals', type: 'post' },
	WITHDRAWAL_CONFIRM: { url: 'member/withdrawals/confirm', type: 'post' },
	PUBLIC_STORE_GET: {
		url: "public/store/get",
		type: "get"
	},
	PUBLIC_PRODUCT: {
		url: "public/product",
		type: "get"
	},
	PUBLIC_PRODUCT_BEST_SELLERS: {
		url: "public/product/best-sellers",
		type: "get"
	},
	PUBLIC_CATEGORY: {
		url: "public/category",
		type: "get"
	},
	PUBLIC_PRODUCT_DETAIL: {
		url: "public/product/detail",
		type: "get"
	},
	COMPANY_ITEM_BY_SLUG: {
		url: "company/slug",
		type: "get"
	},
	PUBLIC_PRODUCT_REVIEW: {
		url: "public/product/review",
		type: "get"
	},
	MEMBER_PRODUCT_REVIEW: {
		url: "member/product/review",
		type: "post"
	},
	TRANSACTION: {
		url: "member/transaction",
		type: "post"
	},
	TRANSACTION_LIST: {
		url: "member/transaction",
		type: "get"
	},
	TRANSACTION_GET: {
		url: "member/transaction/get",
		type: "get"
	},
	TRANSACTION_RESUME: {
		url: "member/transaction/resume",
		type: "put"
	},
	TRANSACTION_DELIVERY_SCHEDULE: {
		url: "member/transaction/delivery-schedule",
		type: "put"
	},
	TRANSACTION_SHIPPING_RECEIVE: {
		url: "member/transaction/shipping/receive",
		type: "put"
	},
	TRANSACTION_COMPLETE: {
		url: "member/transaction/complete",
		type: "put"
	},
	TRANSACTION_COMPLAIN: {
		url: "member/transaction/complain",
		type: "put"
	},



}
